import { render, staticRenderFns } from "./TutorialUploader.vue?vue&type=template&id=656f0bb4&scoped=true"
import script from "./TutorialUploader.vue?vue&type=script&lang=js"
export * from "./TutorialUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656f0bb4",
  null
  
)

export default component.exports